import { AuditTask } from '../types';

interface PaperTaskStatusProps {
  tasks: AuditTask[];
}

/**
 * Display task count and click hint for a paper.
 * Risk level is shown by AuditStatusBadge, not here to avoid duplication.
 */
function PaperTaskStatus({ tasks }: PaperTaskStatusProps) {
  if (!tasks || tasks.length === 0) return null;

  return (
    <span className="text-xs text-blue-500 hover:text-blue-700 underline cursor-pointer">
      {tasks.length}次审查
    </span>
  );
}

export default PaperTaskStatus;
